// @flow

import styled, { css } from 'styled-components';
import { media } from '../../helpers';
import { SEMIBOLD } from '../../helpers/fontWeight';
import Card from '../card';
import type { Theme } from '../../types';

export const Wrapper = styled<any, Theme>('section')`
  display: flex;
  flex-wrap: wrap;
`;

export const ImageContainer = styled<any, Theme>('div')`
  min-height: 7rem;
  img {
    width: 100%;
  }
`;

export const Title = styled<any, Theme>('h3')`
  color: ${props => props.theme.package.titleColor};
  margin-bottom: .5rem;
  font-size: 1.125rem;
  font-weight: ${SEMIBOLD};
`;

export const StyledPrice = styled<any, Theme>('div')`
  color: ${props => props.theme.package.titleColor};
  display: flex;
  font-size: .875rem;
  line-height: 1;
`;

export const StyledCard = styled<typeof Card, Theme>(Card)`
  margin: 1rem;
  width: calc(100% - 2rem);

  ${media.md(css`
    width: calc(50% - 2rem);
  `)}

  ${media.lg(css`
    width: calc(33.33333333333% - 2rem);
  `)}
`;

export const PriceText = styled<any, Theme>('span')`
  margin-left: 0.5rem;
`;

export const CompareWrapper = styled<any, Theme>('div')`
  margin-top: 1rem;
  width: 100%;
`;
